import { useCallback, memo } from 'react';
import PropTypes from 'prop-types';
import Dropdown from '../../Dropdown';
import Filter from '../Filter';
import TwAutocomplete from '../../TwAutocomplete';

import useStyles from './styles';

const MultiSelectAutocompleteFilter = ({
  onChange,
  label,
  options,
  values,
  variant,
  filterMaxWidthClass,
  onInputChange,
  filterSpacingClass,
  childComponent,
  tooltipPrependText,
  fontSize,
  bgClassName,
  freeSolo,
  openOnFocus,
  renderGroup,
  filterOptions,
  getOptionSelected,
}) => {
  const classes = useStyles();
  const isEmpty = !values || !values.length;

  const getLabel = () => (isEmpty ? label : values[0].label);

  const handleChange = useCallback(
    (newValue) => {
      onChange(newValue);
    },
    [onChange],
  );

  const clearFilter = useCallback(() => {
    handleChange([]);
  }, [handleChange]);

  return (
    <Filter
      label={getLabel()}
      menuWidthClass="w-56 md:w-108"
      isFilterEmpty={isEmpty}
      hasCounter
      itemCount={!isEmpty ? values.length - 1 : 0}
      variant={variant}
      filterMaxWidthClass={filterMaxWidthClass}
      handleClear={clearFilter}
      tooltipPrependText={tooltipPrependText}
      filterSpacingClass={filterSpacingClass}
      fontSize={fontSize}
      bgClassName={bgClassName}
    >
      <Dropdown.Item>
        <div className="col-span-5">
          {childComponent}
          <TwAutocomplete
            isMultiple
            placeholderText="Search..."
            onChange={handleChange}
            classes={classes}
            options={options}
            values={values || []}
            isNested
            disableClearable
            disableCloseOnSelect
            onInputChange={onInputChange}
            freeSolo={freeSolo}
            openOnFocus={openOnFocus}
            renderGroup={renderGroup}
            filterOptions={filterOptions}
            getOptionSelected={getOptionSelected}
          />
        </div>
      </Dropdown.Item>
    </Filter>
  );
};

MultiSelectAutocompleteFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  variant: PropTypes.string,
  filterMaxWidthClass: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      suggests: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          label: PropTypes.string,
        }),
      ),
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ),
  values: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
    }),
  ),
  onInputChange: PropTypes.func,
  filterSpacingClass: PropTypes.string,
  childComponent: PropTypes.element,
  tooltipPrependText: PropTypes.string,
  fontSize: PropTypes.string,
  bgClassName: PropTypes.string,
  freeSolo: PropTypes.bool,
  openOnFocus: PropTypes.bool,
  renderGroup: PropTypes.func,
  filterOptions: PropTypes.func,
  getOptionSelected: PropTypes.func,
};

MultiSelectAutocompleteFilter.defaultProps = {
  variant: 'standard',
  filterMaxWidthClass: 'max-w-filter',
  options: undefined,
  values: undefined,
  onInputChange: undefined,
  filterSpacingClass: undefined,
  childComponent: undefined,
  tooltipPrependText: undefined,
  fontSize: undefined,
  bgClassName: undefined,
  freeSolo: true,
  openOnFocus: false,
  renderGroup: undefined,
  filterOptions: undefined,
  getOptionSelected: undefined,
};

export default memo(MultiSelectAutocompleteFilter);
